export default __webpack_public_path__ + "static/media/health-data.3b074d2c.jpg";